Date.prototype.asUTC = function() {
	return new Date(this.getTime() - this.getTimezoneOffset() * 60000)
}
